import { useAuth } from '~/contexts/AuthProvider';
import { useDispatch, useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { RootState } from '~/store/types/sharedTypes';
import { pushToGtmAction } from '~/store/actions/gtmActions';
import { StepStatus } from '~/enums';
import { useCallback } from 'react';
import constVars from '~/constants/constVars';
import posthog from 'posthog-js';

const useLogout = () => {
  const { logout, provider } = useAuth();
  const dispatch = useDispatch();
  const { language: selectedLanguage, market } = useSelector(
    (state: RootState) => state.intl
  );

  return useCallback(
    (returnTo = constVars.ROUTE_LOGIN) => {
      sessionStorage.removeItem('returnTo');
      localStorage.setItem('qredMarket', market);
      localStorage.setItem('qredLoginLanguage', selectedLanguage);
      localStorage.removeItem('active_company');
      localStorage.removeItem('qredLanguage');

      dispatch(
        pushToGtmAction({
          eventName: 'main',
          actionName: 'user_logout',
          stepStatus: StepStatus.Finished,
          stepActionNumber: 1.2,
        })
      );

      const returnToUrl = returnTo.includes('https://')
        ? returnTo
        : `${window.location.origin}/${returnTo}`;

      // Auth0 uses logoutParams, Cognito uses returnTo directly
      const logoutOptions =
        provider === 'auth0'
          ? { logoutParams: { returnTo: returnToUrl } }
          : { returnTo: returnToUrl };

      logout(logoutOptions).then(() => {
        posthog.reset();
        Sentry.setUser(null);
      });
    },
    [selectedLanguage]
  );
};

export default useLogout;
